import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import type { ReplaceMediaControlsButtons} from '@Components/replace-media-controls';
import {ReplaceMediaControls} from '@Components/replace-media-controls';

interface ContextualMenuReplaceMediaControlsProps {
  id: string;
  className?: string;
  controlsClassName?: string;

  onClick(option: ReplaceMediaControlsButtons): void;
  onCancel(): void;
}

export function ContextualMenuReplaceMediaControls({className = '', controlsClassName = '', ...props}: ContextualMenuReplaceMediaControlsProps): ReactElement<any> {
  return (
    <Option
      key={props.id}
      className={`${className}`}
      containerClassName="_full-width"
      showControlInCenter
      optionControl={
        <ReplaceMediaControls
          className={controlsClassName}
          onClick={(id): void => {
            props.onClick(id);
          }}
          onCancel={(): void => {
            props.onCancel();
          }}
        />
      }
    />
  );
}
